import { useEffect, useState } from "react";
import Leftscreen from "./leftscreen/Leftscreen";
import Rightscreen from "./right-screen/Rightscreen";
import { ToggleButton } from "./right-screen/Rightscreen";
import { TabData } from "../../components/InterfaceInfo";
import HeatMap from "./heat-map/HeatMap";
import { KeyboardDoubleArrowUp } from "@mui/icons-material";
import { IconButton, Tab, Tabs } from "@mui/material";

const tabData: TabData = JSON.parse(process.env.REACT_APP_TAB || '{}');

function HomePage({ menuIndex }: { menuIndex: number }) {
    const [isRightSidebarVisible, setIsRightSidebarVisible] = useState(true);
    const [isSidePanelVisible, setIsSidePanelVisible] = useState(false)
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);

    const hasLeftSidebar = tabData.details_of_menus[menuIndex]?.left_screen?.exists;
    const hasRightSidebar = tabData.details_of_menus[menuIndex]?.right_screen?.exists;

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

      // MOBILE VIEW
  if (isMobile) {
    // 1) Right panel open
    if (hasRightSidebar && isRightSidebarVisible) {
      return (
        <div className="fixed top-14 left-0 right-0 bottom-0 overflow-hidden bg-white">
          <aside className="h-full w-full overflow-y-auto bg-white">
            <Rightscreen
              menuIndex={menuIndex}
              handleClick={setIsRightSidebarVisible}
            />
          </aside>
        </div>
      );
    }

    // 2) Right panel closed 
    return (
      <div className="fixed top-14 left-0 right-0 bottom-0 flex flex-col overflow-hidden bg-white">
        <main className="flex-1 min-h-0 overflow-hidden">
          <HeatMap isRightSidebarVisible={false} />
        </main>

        {hasLeftSidebar && isSidePanelVisible && (
          <aside className="h-[50%] min-h-[220px] max-h-[350px] overflow-y-auto border-t bg-white">
            <Leftscreen isMobile={true} menuIndex={menuIndex} setIsSidePanelVisible={setIsSidePanelVisible} />
          </aside>
        )}

        {!isSidePanelVisible && hasLeftSidebar && (
                <Tabs value={0} color='primary' aria-label="dynamic tabs example" variant="fullWidth" sx={{
                    flexShrink: 0,
                    borderBottom: 1,
                    borderColor: 'divider',
                    backgroundColor: 'grey.300',
                    fontFamily: {
                        'sans': ['Titillium Web', 'Roboto Mono', 'Helvetica', 'Arial', 'sans-serif'],
                    },
                }}>
                    <Tab sx={{
                        textAlign: 'center',
                        textTransform: 'none',
                        backgroundColor: 'grey.200',
                        borderBottom: 'brand',
                        color: 'green',
                        '&.Mui-selected': {
                            color: 'green',
                        },
                        '&:hover': {
                            backgroundColor: 'grey.300',
                        },
                        minHeight: '40px',
                        height: '50px',
                        padding: '6px 12px',
                        '& .MuiTab-iconWrapper': {
                            marginLeft: '4px',
                        },
                        flexGrow: 1, // Allow the tab to grow
                    }} color='primary' label={'Section Track Settings'} iconPosition="end"
                        icon={
                            isMobile ? (
                                <IconButton onClick={() => setIsSidePanelVisible(true)}>
                                    <KeyboardDoubleArrowUp color="primary" />
                                </IconButton>
                            ) : undefined
                        } />
                </Tabs>
        )}

        {hasRightSidebar && (
          <div className="absolute right-3 top-3 z-[1006]">
            <ToggleButton
              value={true}
              styleName="bg-white hover:bg-gray-100 shadow-md"
              handleClick={setIsRightSidebarVisible}
            />
          </div>
        )}
      </div>
    );
  }

    return (
        <div className="fixed top-14 left-0 right-0 bottom-0 flex flex-row overflow-hidden">
            {hasLeftSidebar && (
                <aside
                    className={`
                        ts-sidebar shrink-0 overflow-y-auto transition-all
                        w-[42vw] min-w-[7rem] max-w-[14rem]
                        sm:w-[16rem] sm:max-w-none
                        lg:w-[23rem]
                    `}
                >
                    <Leftscreen menuIndex={menuIndex} setIsSidePanelVisible={setIsSidePanelVisible} />
                </aside>
            )}

            <main
                className={`
                    relative min-w-0 flex-1 overflow-hidden
                    ${hasRightSidebar && isRightSidebarVisible ? "lg:mr-[25rem]" : ""}
                `}
            >
                <div className="h-full w-full">
                    <HeatMap isRightSidebarVisible={isRightSidebarVisible} />
                </div>
            </main>

            {hasRightSidebar && (
                <>
                    {isRightSidebarVisible ? (
                        <aside
                            className={`
                                ts-sidebar absolute right-0 top-0 bottom-0 z-[1006]
                                flex flex-col bg-white shadow-2xl overflow-x-hidden overflow-y-auto
                                transition-transform duration-300

                                w-full
                                sm:w-[20rem]
                                lg:w-[25rem]
                            `}
                        >
                            <Rightscreen
                                menuIndex={menuIndex}
                                handleClick={setIsRightSidebarVisible}
                            />
                        </aside>
                    ) : (
                        <aside
                            className={`
                                ts-sidebar absolute right-0 top-0 bottom-0 z-[1006]
                                flex flex-col overflow-x-hidden overflow-y-auto
                                transition-transform duration-300

                                w-[3.5rem]
                                lg:w-[5rem]
                            `}
                        >
                            <ToggleButton
                                value={true}
                                styleName="bg-white hover:bg-gray-100"
                                handleClick={setIsRightSidebarVisible}
                            />
                        </aside>
                    )}
                </>
            )}
        </div>
    );
}

export default HomePage;
